import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { RenderIf } from '../../utils/RenderIf';
import loading from '../img/loading.gif';
import checkimg from '../img/check.png';
import cancel from '../img/cancel.png';
import warning from '../img/warning.png';
import { Button } from 'react-bootstrap';

// ...existing code...
export const ModalStatusPayment = ({ showModalStatusPayment, setShowModalStatusPayment, paymentInfo, paymentApproval, invoiceSubtotal, invoiceTotal, invoiceTotalDiscount, invoiceTotalItbms, invoiceTip, invoiceDeliveryFee }) => {


    return (
        <>
            <Modal
                centered
                className='modal-dialog-kk'
                fullscreen
                show={showModalStatusPayment}
                onHide={() => setShowModalStatusPayment(false)}
                contentClassName="ypy-modal-content"
            >

                <Modal.Body className='section-message-yappy ypy-modal-body'>

                    {/* Fondo animado (decorativo) */}
                    <div className="ypy-bg" aria-hidden="true">
                        <span className="ypy-blob ypy-blob--1"></span>
                        <span className="ypy-blob ypy-blob--2"></span>
                        <span className="ypy-blob ypy-blob--3"></span>
                        <span className="ypy-blob ypy-blob--4"></span>
                        <span className="ypy-blob ypy-blob--5"></span>
                    </div>

                    <main className="ypy-page">
                        <section className="ypy-card ypy-status-card" aria-live="polite">

                            <div className="ypy-status">

                                {/* 0. Procesando */}
                                <RenderIf isTrue={paymentApproval.status == 0}>
                                    <div className="ypy-status-icon ypy-tone-wait">
                                        <img src={loading} alt="" width={72} />
                                    </div>
                                    <h2 className="ypy-status-title">{paymentApproval.description}</h2>
                                    <p className="ypy-status-text">No cierres esta pantalla mientras confirmamos tu pago.</p>
                                    <span className="ypy-method-chip">Método de pago: {paymentInfo?.payment || ""}</span>
                                </RenderIf>

                                {/* 1. Pago aprobado */}
                                <RenderIf isTrue={paymentApproval.status == 1}>
                                    <div className="ypy-status-icon ypy-tone-ok">
                                        <img src={checkimg} alt="" width={64} />
                                    </div>
                                    <h2 className="ypy-status-title">¡Éxito!</h2>
                                    <p className="ypy-status-text">Su pago ha sido procesado correctamente.</p>
                                    <span className="ypy-method-chip">Método de pago: {paymentInfo?.payment || ""}</span>
                                </RenderIf>

                                {/* 2. Pago fallido */}
                                <RenderIf isTrue={paymentApproval.status == 2}>
                                    <div className="ypy-status-icon ypy-tone-error">
                                        <img src={cancel} alt="" width={60} />
                                    </div>
                                    <h2 className="ypy-status-title">{paymentApproval.description}</h2>
                                    <p className="ypy-status-text">Por favor, verifique la información e intente nuevamente.</p>
                                    <span className="ypy-method-chip">Método de pago: {paymentInfo?.payment || ""}</span>
                                </RenderIf>

                                {/* 3. Pago rechazado (con acciones) */}
                                <RenderIf isTrue={paymentApproval.status == 3}>
                                    <div className="ypy-status-icon ypy-tone-error">
                                        <img src={cancel} alt="" width={60} />
                                    </div>
                                    <h2 className="ypy-status-title">{paymentApproval.description}</h2>
                                    <p className="ypy-status-text">Por favor, verifique la información e intente nuevamente.</p>
                                    <span className="ypy-method-chip">Método de pago: {paymentInfo?.payment || ""}</span>

                                    <div className="ypy-status-actions">
                                        <Button className="ypy-btn ypy-btn-ghost">Volver</Button>
                                        <Button className="ypy-btn ypy-btn-primary">Intentar de nuevo</Button>
                                    </div>
                                </RenderIf>

                                {/* 4. Pago pendiente de aprobación */}
                                <RenderIf isTrue={paymentApproval.status === 4}>
                                    <div className="ypy-status-icon ypy-tone-warn">
                                        <img src={warning} alt="" width={64} />
                                    </div>
                                    <h2 className="ypy-status-title">{paymentApproval.description}</h2>
                                    <p className="ypy-status-text">Advertencia.</p>
                                    <span className="ypy-method-chip">Método de pago: {paymentInfo?.payment || ""}</span>
                                </RenderIf>
                            </div>

                            {/* Detalle del desglose */}
                            <dl className="ypy-breakdown" translate="no">
                                <div className="ypy-row">
                                    <dt>Descuento</dt>
                                    <dd className="ypy-row-discount">- ${invoiceTotalDiscount.toFixed(2)}</dd>
                                </div>
                                <div className="ypy-row">
                                    <dt>Subtotal</dt>
                                    <dd>${invoiceSubtotal.toFixed(2)}</dd>
                                </div>
                                <div className="ypy-row">
                                    <dt>Entrega a domicilio</dt>
                                    <dd>${invoiceDeliveryFee.toFixed(2)}</dd>
                                </div>
                                <div className="ypy-row">
                                    <dt>ITBMS</dt>
                                    <dd>${invoiceTotalItbms.toFixed(2)}</dd>
                                </div>

                                {invoiceTip > 0 ? <>
                                    <div className="ypy-row">
                                        <dt>Propina</dt>
                                        <dd>${invoiceTip.toFixed(2)}</dd>
                                    </div>
                                </> : <></>}

                                <div className="ypy-row ypy-row-total">
                                    <dt>Total <small>(+ITBMS)</small></dt>
                                    <dd>${invoiceTotal.toFixed(2)}</dd>
                                </div>
                            </dl>
                        </section>
                    </main>

                </Modal.Body>
            </Modal>
        </>)
}

export default ModalStatusPayment
